function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AllTransactionsTemplate = require('./all-transactions.template');
var _require = require('../explorer-format'),
  formatTransactionsForTeaser = _require.formatTransactionsForTeaser,
  extractTransactionsFromBlocks = _require.extractTransactionsFromBlocks,
  mergeBlockByHash = _require.mergeBlockByHash;
var _require2 = require('../peer/client'),
  sendExplorerPeerRequest = _require2.sendExplorerPeerRequest;
var _require3 = require('../module-detect'),
  detectTransactionModule = _require3.detectTransactionModule;
var PAGE_SIZE = 25;
var TX_ENRICH_COUNT = 5;
var AllTransactions = /*#__PURE__*/function () {
  function AllTransactions(app, mod) {
    _classCallCheck(this, AllTransactions);
    this.app = app;
    this.mod = mod;
    this.container = '.explorer-view';
    this.rawBlocks = [];
    this.rawTransactions = [];
    this.loading = true;
    this.loadingMore = false;
    this.hasMore = true;
    this.error = null;
    this.scrollHandler = null;
  }
  return _createClass(AllTransactions, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.rawBlocks = [];
      this.rawTransactions = [];
      this.loading = true;
      this.loadingMore = false;
      this.hasMore = true;
      this.error = null;
      this.paint();
      this.loadInitial();
    }
  }, {
    key: "formatTransactions",
    value: function formatTransactions() {
      var app = this.app;
      var formatted = formatTransactionsForTeaser(app, this.rawTransactions, this.rawTransactions.length);
      for (var i = 0; i < formatted.length && i < this.rawTransactions.length; i++) {
        var raw = this.rawTransactions[i];
        var moduleName = detectTransactionModule(raw);
        formatted[i].module = app.browser.escapeHTML(moduleName);
      }
      return formatted;
    }
  }, {
    key: "paint",
    value: function paint() {
      var transactions = this.loading && !this.rawTransactions.length ? [] : this.formatTransactions();
      this.app.browser.replaceElementContentBySelector(AllTransactionsTemplate({
        transactions: transactions,
        loading: this.loading,
        loadingMore: this.loadingMore,
        hasMore: this.hasMore,
        error: this.error
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      document.querySelectorAll('.explorer-all-tx-feed .explorer-transaction-card[data-tx-signature]').forEach(function (el) {
        var navigate = function navigate(event) {
          var _event$target, _event$preventDefault;
          if (event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.closest('.explorer-pubkey-link')) {
            return;
          }
          event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
          var signature = el.getAttribute('data-tx-signature');
          if (!signature) return;
          var blockHash = el.getAttribute('data-block-hash') || '';
          if (!blockHash) {
            blockHash = _this.mod.resolveBlockHash('', el.getAttribute('data-block-id'));
          }
          if (!blockHash) return;
          _this.cleanup();
          _this.mod.renderBlock(blockHash, {
            pushState: true,
            animate: true,
            expandTxSignature: signature
          });
        };
        el.onclick = navigate;
        el.onkeydown = function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            navigate(event);
          }
        };
      });
      var loadMoreBtn = document.querySelector('.explorer-load-more-btn');
      if (loadMoreBtn) {
        loadMoreBtn.onclick = function () {
          return _this.loadMore();
        };
      }
      this.setupScrollListener();
    }
  }, {
    key: "setupScrollListener",
    value: function setupScrollListener() {
      var _this2 = this;
      this.cleanupScroll();
      this.scrollHandler = function () {
        if (_this2.loadingMore || !_this2.hasMore) return;
        var sentinel = document.querySelector('.explorer-load-more');
        if (!sentinel) return;
        var rect = sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 200) {
          _this2.loadMore();
        }
      };
      window.addEventListener('scroll', this.scrollHandler, {
        passive: true
      });
    }
  }, {
    key: "cleanupScroll",
    value: function cleanupScroll() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
        this.scrollHandler = null;
      }
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      this.cleanupScroll();
    }
  }, {
    key: "getSmallestBlockId",
    value: function getSmallestBlockId() {
      var smallest = Infinity;
      for (var i = 0; i < this.rawBlocks.length; i++) {
        var _this$rawBlocks$i;
        var id = Number((_this$rawBlocks$i = this.rawBlocks[i]) === null || _this$rawBlocks$i === void 0 ? void 0 : _this$rawBlocks$i.id);
        if (Number.isFinite(id) && id < smallest) {
          smallest = id;
        }
      }
      return Number.isFinite(smallest) ? smallest : null;
    }
  }, {
    key: "requestBlockPromise",
    value: function requestBlockPromise(peer, identifier) {
      var _this3 = this;
      var data = {
        request: 'request block',
        include_transactions: true
      };
      if (typeof identifier === 'bigint' || typeof identifier === 'number') {
        data.block_id = String(identifier);
      } else {
        data.hash = String(identifier);
      }
      return new Promise(function (resolve) {
        sendExplorerPeerRequest(_this3.app, 'request block', {
          data: data,
          callback: function callback(response) {
            if (response !== null && response !== void 0 && response.success && response.data) {
              resolve(response.data);
              return;
            }
            resolve(null);
          },
          peer: peer
        });
      });
    }
  }, {
    key: "enrichBlocksWithTransactions",
    value: function () {
      var _enrichBlocksWithTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(peer, blocks) {
        var enrichCount, requests, i, _blocks$i, _blocks$i2, id, results, enriched, _iterator, _step, fullBlock;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              enrichCount = Math.min(TX_ENRICH_COUNT, blocks.length);
              requests = [];
              for (i = 0; i < enrichCount; i++) {
                id = ((_blocks$i = blocks[i]) === null || _blocks$i === void 0 ? void 0 : _blocks$i.hash) || ((_blocks$i2 = blocks[i]) === null || _blocks$i2 === void 0 ? void 0 : _blocks$i2.id);
                if (id != null && id !== '') {
                  requests.push(this.requestBlockPromise(peer, id));
                }
              }
              _context.n = 1;
              return Promise.all(requests);
            case 1:
              results = _context.v;
              enriched = blocks.slice();
              _iterator = _createForOfIteratorHelper(results);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  fullBlock = _step.value;
                  if (fullBlock) {
                    enriched = mergeBlockByHash(enriched, fullBlock);
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return _context.a(2, enriched);
          }
        }, _callee, this);
      }));
      function enrichBlocksWithTransactions(_x, _x2) {
        return _enrichBlocksWithTransactions.apply(this, arguments);
      }
      return enrichBlocksWithTransactions;
    }()
  }, {
    key: "loadInitial",
    value: function () {
      var _loadInitial = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var peer, headerBlocks, enriched, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              peer = this.mod.explorerPeer;
              if (peer) {
                _context2.n = 1;
                break;
              }
              this.loading = false;
              this.error = 'Waiting for Explorer peer connection.';
              this.paint();
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return this.requestBlocksPromise(peer, {
                count: PAGE_SIZE,
                include_offchain: false
              });
            case 2:
              headerBlocks = _context2.v;
              if (headerBlocks.length) {
                _context2.n = 3;
                break;
              }
              this.loading = false;
              this.hasMore = false;
              this.paint();
              return _context2.a(2);
            case 3:
              _context2.n = 4;
              return this.enrichBlocksWithTransactions(peer, headerBlocks);
            case 4:
              enriched = _context2.v;
              this.rawBlocks = enriched;
              this.rawTransactions = extractTransactionsFromBlocks(enriched);
              this.loading = false;
              this.hasMore = headerBlocks.length >= PAGE_SIZE;
              this.paint();
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              this.loading = false;
              this.error = 'Failed to load transactions.';
              this.paint();
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5]]);
      }));
      function loadInitial() {
        return _loadInitial.apply(this, arguments);
      }
      return loadInitial;
    }()
  }, {
    key: "requestBlocksPromise",
    value: function requestBlocksPromise(peer, options) {
      var _options$count,
        _options$include_offc,
        _this4 = this;
      var count = (_options$count = options.count) !== null && _options$count !== void 0 ? _options$count : 10;
      var includeOffchain = (_options$include_offc = options.include_offchain) !== null && _options$include_offc !== void 0 ? _options$include_offc : true;
      var data = {
        request: 'request blocks',
        count: count,
        include_offchain: includeOffchain
      };
      if (options.before_id != null) {
        data.before_id = Number(options.before_id);
      }
      return new Promise(function (resolve) {
        sendExplorerPeerRequest(_this4.app, 'request blocks', {
          data: data,
          callback: function callback(response) {
            if (response !== null && response !== void 0 && response.err || !(response !== null && response !== void 0 && response.success)) {
              resolve([]);
              return;
            }
            resolve(Array.isArray(response.data) ? response.data : []);
          },
          peer: peer
        });
      });
    }
  }, {
    key: "loadMore",
    value: function () {
      var _loadMore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var peer, beforeId, headerBlocks, enriched, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(this.loadingMore || !this.hasMore)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              peer = this.mod.explorerPeer;
              if (peer) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              beforeId = this.getSmallestBlockId();
              if (!(!beforeId || beforeId <= 1)) {
                _context3.n = 3;
                break;
              }
              this.hasMore = false;
              this.paint();
              return _context3.a(2);
            case 3:
              this.loadingMore = true;
              this.paint();
              _context3.p = 4;
              _context3.n = 5;
              return this.requestBlocksPromise(peer, {
                count: PAGE_SIZE,
                include_offchain: false,
                before_id: beforeId
              });
            case 5:
              headerBlocks = _context3.v;
              if (headerBlocks.length) {
                _context3.n = 6;
                break;
              }
              this.loadingMore = false;
              this.hasMore = false;
              this.paint();
              return _context3.a(2);
            case 6:
              _context3.n = 7;
              return this.enrichBlocksWithTransactions(peer, headerBlocks);
            case 7:
              enriched = _context3.v;
              this.rawBlocks = this.rawBlocks.concat(enriched);
              this.rawTransactions = extractTransactionsFromBlocks(this.rawBlocks);
              this.loadingMore = false;
              this.hasMore = headerBlocks.length >= PAGE_SIZE;
              this.paint();
              _context3.n = 9;
              break;
            case 8:
              _context3.p = 8;
              _t2 = _context3.v;
              this.loadingMore = false;
              this.hasMore = false;
              this.paint();
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[4, 8]]);
      }));
      function loadMore() {
        return _loadMore.apply(this, arguments);
      }
      return loadMore;
    }()
  }]);
}();
module.exports = AllTransactions;